/**
 * Le titre de la page — la première chose qu'un lecteur d'écran annonce.
 *
 * Toutes les pages de la boutique s'appelaient « Les Folies Maraîchères »
 * (mesuré le 15/09/2026 sur les quatre pages principales). Passer du catalogue
 * au panier annonçait donc exactement la même phrase : impossible, à l'oreille,
 * de savoir que la page avait changé. C'est aussi ce qui distingue deux onglets
 * ouverts et ce qui nomme un favori.
 *
 * Le nom du magasin reste à la fin : ce qui change vient en premier, parce que
 * c'est ce qu'on entend avant de couper.
 */
import { useEffect } from 'react';

const MAGASIN = 'Les Folies Maraîchères';

export function useTitrePage(titre?: string | null) {
  useEffect(() => {
    const precedent = document.title;
    document.title = titre ? `${titre} — ${MAGASIN}` : MAGASIN;
    // On rend le titre précédent en quittant : sans cela, revenir en arrière
    // depuis une page qui en pose un laisserait le titre de celle qu'on quitte.
    return () => {
      document.title = precedent;
    };
  }, [titre]);
}
